import * as types from '../types'
import initialState from '../initialState'

export default function userReducer(state = initialState.user, action) {
    switch (action.type) {
        case types.LOGIN:
            return { user: action?.payload ?? null }
        case types.SET_USER:
            return { ...state, user: action?.payload ?? state.user }
        case types.LOGOUT:
            return { user: null }
        case types.REFRESHON:
            return { ...state, tokenRefreshing: true }
        case types.REFRESHOFF:
            return { ...state, tokenRefreshing: false }
        case types.REFRESHTOKEN:
            return { ...state, user: action.payload }
        default:
            return state
    }
}
